import { render, staticRenderFns } from "./PostVideo.vue?vue&type=template&id=3351f50a&scoped=true&"
import script from "./PostVideo.vue?vue&type=script&lang=js&"
export * from "./PostVideo.vue?vue&type=script&lang=js&"
import style0 from "./PostVideo.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PostVideo.vue?vue&type=style&index=1&id=3351f50a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3351f50a",
  null
  
)

export default component.exports